import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { Box, Stack, Typography } from "@mui/material";
import {
  DatePicker as MUIDatePicker,
  TimePicker,
  DateTimePicker,
} from "@mui/x-date-pickers-pro";

const DatePicker: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(dayjs());
  const [selectedTime, setSelectedTime] = useState<Dayjs | null>(dayjs());
  const [selectedDateTime, setSelectedDateTime] = useState<Dayjs | null>(
    dayjs(),
  );

  return (
    <Stack spacing={4}>
      {/* Date Picker */}
      <Box>
        <Typography variant="h6" gutterBottom>
          Date Picker
        </Typography>
        <MUIDatePicker
          label="Select Date"
          value={selectedDate}
          onChange={(newValue) => setSelectedDate(newValue)}
        />
      </Box>

      {/* Time Picker */}
      <Box>
        <Typography variant="h6" gutterBottom>
          Time Picker
        </Typography>
        <TimePicker
          label="Select Time"
          value={selectedTime}
          onChange={(newValue) => setSelectedTime(newValue)}
          shouldDisableTime={(timeValue, clockType) => {
            if (clockType === "hours") {
              return timeValue.hour() < dayjs().hour();
            }

            return false;
          }}
        />
      </Box>

      {/* DateTime Picker */}
      <Box>
        <Typography variant="h6" gutterBottom>
          DateTime Picker
        </Typography>
        <DateTimePicker
          label="Select Date & Time"
          value={selectedDateTime}
          onChange={(newValue) => setSelectedDateTime(newValue)}
        />
      </Box>
    </Stack>
  );
};

export default DatePicker;
